import {
  CalendarIcon,
  DocumentTextIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";
import {
  Card,
  Center,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Title,
  rem,
} from "@mantine/core";
import { Breadcrumb } from "../../components/common/Breadcrumb";

export function OperationsTemplates() {
  // Function to render icons with consistent styling
  const renderIcon = (Icon: any) => (
    <Icon
      style={{
        width: rem(48),
        height: rem(48),
        color: "var(--mantine-color-gray-7)",
      }}
    />
  );

  return (
    <Container size="xl" py="xl">
      <Stack gap="xs" mb="xl">
        <Breadcrumb
          items={[
            { label: "Operations Panel", href: "/operations" },
            { label: "Templates", isActive: true },
          ]}
        />
      </Stack>
      <Stack gap="xs" mb="xl">
        <Title order={1} size="h2" fw={700}>
          Templates for export
        </Title>
        <Text c="dimmed" size="lg">
          Manage templates for CVs and Reference Projects
        </Text>
      </Stack>

      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
        {/* CV Templates Card */}
        <Card
          p="xl"
          radius="md"
          withBorder
          shadow="sm"
          style={{ cursor: "pointer" }}
        >
          <Stack gap="md" align="center">
            <Center>{renderIcon(DocumentTextIcon)}</Center>
            <Stack gap={5} align="center">
              <Text fw={600} size="lg">
                CV templates
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                Templates for CV export
              </Text>
            </Stack>
          </Stack>
        </Card>

        {/* Reference Templates Card */}
        <Card
          p="xl"
          radius="md"
          withBorder
          shadow="sm"
          style={{ cursor: "pointer" }}
        >
          <Stack gap="md" align="center">
            <Center>{renderIcon(TableCellsIcon)}</Center>
            <Stack gap={5} align="center">
              <Text fw={600} size="lg">
                Reference templates
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                Templates for reference project export
              </Text>
            </Stack>
          </Stack>
        </Card>

        {/* Date Format Card */}
        <Card
          p="xl"
          radius="md"
          withBorder
          shadow="sm"
          style={{ cursor: "pointer" }}
        >
          <Stack gap="md" align="center">
            <Center>{renderIcon(CalendarIcon)}</Center>
            <Stack gap={5} align="center">
              <Text fw={600} size="lg">
                Select date format
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                How to export dates and 'today's date'
              </Text>
            </Stack>
          </Stack>
        </Card>
      </SimpleGrid>
    </Container>
  );
}
